import { useParams } from "react-router-dom";
import FullImage from "./pages/FullImage";
import { shortDecrypt } from "./crypto";
import Error404 from "./Error404";
import Error401 from "./Error401";

const adminAuthorized = ['dashboard', 'imageupload', 'updateColors', 'subcategoryadd', 'offerupdate', ]

export default function ProtectedFullImage() {
  const { enc } = useParams();

  const decoded = shortDecrypt(enc);

  if (decoded === "fullimage") {
    return <FullImage />;
  }

  if (adminAuthorized.includes(enc)) {
    return <Error401 />
  }

  return <Error404 />;
}
